import styled, { css } from 'styled-components';
import {device} from "../../../styles/responsive/responsiveUtils";

export const StyledModalLoader = styled.div`
  min-height: ${({ minHeight }) => minHeight ?? '400px'};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 700px;
}
`;

export const EmptyTable = styled.div`
    font-size: 18px;
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const StyledWrapperTable = styled.div`
    min-width: 660px;
    overflow-x: auto;
`

export const StyledBanListTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`

export const StyledBanListTableHead = styled.thead`
    font-size: 14px;
    color: ${({theme}) => theme.moderatorsListModal.headTextColor};
    text-transform: uppercase;

    tr:last-child {
        padding-right: 14px;
        text-align: right;
    }
`

export const StyledBanListTableBody = styled.tbody`
    & tr:nth-child(2n) {
        background-color: ${({theme}) => theme.moderatorsListModal.backgroundItemTableColor};
    }

    tr:last-child {
        padding-right: 14px;
    }
`

export const StyledBanListTableRow = styled.tr`
    height: 40px;
`

export const StyledBanListTableItem = styled.td`
    text-align: center;
    border-spacing: 0 !important;
    padding: 0;
    font-size: 14px;
    font-weight: 400;

    &:first-child {
        padding-left: 14px;
        text-align: left;
    }

    .wrapper-link {
        cursor: pointer;
        border-bottom: 1px ${({theme}) => theme.mainTextColor} dashed;
        transition: all 0.3s ease-out;
        display: inline;

        &.user-tag {
            color: ${({theme}) => theme.secondTextColor};
        }

        &:hover, &.user-tag:hover {
            color: #ffffff;
            border-bottom: 1px #ffffff dashed;
        }

        img {
            height: 11px;
            margin-right: 5px;
        }
    }

    button {
        margin: 0;
        text-align: center;
        background: none;
        border: none;
        font-size: 20px;
        color: ${({theme}) => theme.notification.iconColor.error};
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    button:hover, .button:focus {
        border: none;
        background: none;
    }

    & .flex-inline {

        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 5px;
        margin-left: 25px;

        &.between {
            justify-content: space-between;
        }

        .radio__input, .checkbox__input {
            margin-right: 10px;
            position: absolute;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
        }

        .custom-radio, .custom-checkbox {
            width: 20px;
            height: 20px;
            background-image: url(${({ theme }) => theme.backgroundCheckboxInput});
            background-position: -160px 0;
            cursor: pointer;
        }

        .custom-checkbox {
            background-position: -5px 0;
        }

        .radio__input {
            &:checked + .custom-radio {
                background-position: -222px 0;
            }
        }

        .checkbox__input {
            &:checked + .custom-checkbox {
                background-position: -67px 0;
            }
        }

        label {
            z-index: 2;
        }

        label:not(.without-padding) {
            margin-left: -1.5em;
            padding-left: 1.7em;
        }

        .limits-label {
            min-width: 0;

            @media screen and ${device('xs')} {
                min-width: 152px;
            }
        }
    }
`